import { ViewportScroller } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
	private navigationChange = new Subject<void>();
	navigationChange$ = this.navigationChange.asObservable();

	constructor(
		private router: Router,
		private viewportScroller: ViewportScroller
	) {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.viewportScroller.scrollToPosition([0, 0]);
				this.navigationChange.next();
			}
		});
	}
}
